export default "__VITE_ASSET__BRjHNL$a__"